<template>
  <EConditionIcon v-if="mappedCode" :code="mappedCode" />
</template>

<script>
import EConditionIcon from '../condition-icon';
import mapping from './mapping';

export default {
  name: 'EAccuweatherIcon',
  components: {
    EConditionIcon,
  },
  props: {
    code: {
      type: Number,
      required: true,
    },
  },
  computed: {
    mappedCode() {
      return mapping[this.code];
    },
  },
};
</script>
